import { render, staticRenderFns } from "./HelpDeskCaptureOrUploadScreenshot.vue?vue&type=template&id=10812fd0&scoped=true"
import script from "./HelpDeskCaptureOrUploadScreenshot.vue?vue&type=script&lang=js"
export * from "./HelpDeskCaptureOrUploadScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10812fd0",
  null
  
)

export default component.exports